import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from './firebase';

const AdminDashboardPage = () => {
  const [activeTab, setActiveTab] = useState('contact');
  const [submissions, setSubmissions] = useState([]);
  const [distributorApps, setDistributorApps] = useState([]);
  const [newsletterSubs, setNewsletterSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubmissions = async () => {
      setLoading(true);
      try {
        if (activeTab === 'contact') {
          const q = query(collection(db, 'contact-messages'), orderBy('submittedAt', 'desc'));
          const snapshot = await getDocs(q);
          const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setSubmissions(data);
        } else if (activeTab === 'distributor') {
          const q = query(collection(db, 'distributor-applications'), orderBy('submittedAt', 'desc'));
          const snapshot = await getDocs(q);
          const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setDistributorApps(data);
        } else if (activeTab === 'newsletter') {
          const q = query(collection(db, 'newsletter-subscribers'), orderBy('subscribedAt', 'desc'));
          const snapshot = await getDocs(q);
          const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setNewsletterSubs(data);
        }
      } catch (err) {
        setSubmissions([]);
        setDistributorApps([]);
        setNewsletterSubs([]);
      }
      setLoading(false);
    };
    fetchSubmissions();
  }, [activeTab]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f7f7f7' }}>
      {/* Sidebar */}
      <aside style={{ width: 220, background: '#222', color: '#fff', padding: 32, minHeight: '100vh' }}>
        <h2 style={{ fontSize: 22, marginBottom: 32 }}>Admin Panel</h2>
        <div
          style={{
            padding: '12px 0',
            cursor: 'pointer',
            background: activeTab === 'contact' ? '#359F95' : 'none',
            borderRadius: 6,
            marginBottom: 8,
            textAlign: 'left',
            fontWeight: 600,
            paddingLeft: 16,
            color: activeTab === 'contact' ? '#fff' : '#eee',
            transition: 'background 0.2s',
          }}
          onClick={() => setActiveTab('contact')}
        >
          Contact Us Submissions
        </div>
        <div
          style={{
            padding: '12px 0',
            cursor: 'pointer',
            background: activeTab === 'distributor' ? '#359F95' : 'none',
            borderRadius: 6,
            marginBottom: 8,
            textAlign: 'left',
            fontWeight: 600,
            paddingLeft: 16,
            color: activeTab === 'distributor' ? '#fff' : '#eee',
            transition: 'background 0.2s',
          }}
          onClick={() => setActiveTab('distributor')}
        >
          Distributor Applications
        </div>
        <div
          style={{
            padding: '12px 0',
            cursor: 'pointer',
            background: activeTab === 'newsletter' ? '#359F95' : 'none',
            borderRadius: 6,
            marginBottom: 8,
            textAlign: 'left',
            fontWeight: 600,
            paddingLeft: 16,
            color: activeTab === 'newsletter' ? '#fff' : '#eee',
            transition: 'background 0.2s',
          }}
          onClick={() => setActiveTab('newsletter')}
        >
          Newsletter Subscribers
        </div>
      </aside>
      {/* Main Content */}
      <main style={{ flex: 1, padding: 40 }}>
        {activeTab === 'contact' && (
          <div>
            <h2 style={{ marginBottom: 24 }}>Contact Us Submissions</h2>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                  <thead>
                    <tr style={{ background: '#f0f0f0' }}>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Name</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Email</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Phone</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Subject</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Message</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Submitted At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {submissions.length === 0 ? (
                      <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24 }}>No submissions found.</td></tr>
                    ) : (
                      submissions.map(sub => (
                        <tr key={sub.id}>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.name}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.email}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.phone}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.subject}</td>
                          <td style={{ padding: 10, border: '1px solid #eee', maxWidth: 300, wordBreak: 'break-word' }}>{sub.message}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.submittedAt?.toDate ? sub.submittedAt.toDate().toLocaleString() : ''}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {activeTab === 'distributor' && (
          <div>
            <h2 style={{ marginBottom: 24 }}>Distributor Applications</h2>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                  <thead>
                    <tr style={{ background: '#f0f0f0' }}>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Company</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Name</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Email</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Phone</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Country</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>City</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Years</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Distributes</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Brands</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Why</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Submitted At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {distributorApps.length === 0 ? (
                      <tr><td colSpan={11} style={{ textAlign: 'center', padding: 24 }}>No applications found.</td></tr>
                    ) : (
                      distributorApps.map(app => (
                        <tr key={app.id}>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.company}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.name}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.email}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.phone}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.country}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.city}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.years}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.distributes}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.brands}</td>
                          <td style={{ padding: 10, border: '1px solid #eee', maxWidth: 300, wordBreak: 'break-word' }}>{app.why}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{app.submittedAt?.toDate ? app.submittedAt.toDate().toLocaleString() : ''}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {activeTab === 'newsletter' && (
          <div>
            <h2 style={{ marginBottom: 24 }}>Newsletter Subscribers</h2>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                  <thead>
                    <tr style={{ background: '#f0f0f0' }}>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Email</th>
                      <th style={{ padding: 12, border: '1px solid #eee' }}>Subscribed At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {newsletterSubs.length === 0 ? (
                      <tr><td colSpan={2} style={{ textAlign: 'center', padding: 24 }}>No subscribers found.</td></tr>
                    ) : (
                      newsletterSubs.map(sub => (
                        <tr key={sub.id}>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.email}</td>
                          <td style={{ padding: 10, border: '1px solid #eee' }}>{sub.subscribedAt?.toDate ? sub.subscribedAt.toDate().toLocaleString() : ''}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default AdminDashboardPage; 